import { render, staticRenderFns } from "./FormInputSelect.vue?vue&type=template&id=60542143&scoped=true&"
import script from "./FormInputSelect.vue?vue&type=script&lang=js&"
export * from "./FormInputSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormInputSelect.vue?vue&type=style&index=0&id=60542143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60542143",
  null
  
)

export default component.exports